<button
  mat-icon-button
  class="!absolute right-2 top-2 z-10 !bg-white !shadow-md"
  [matMenuTriggerFor]="attachmentMenu"
  (click)="$event.stopPropagation()"
>
  <mat-icon>more_vert</mat-icon>
</button>

<mat-menu #attachmentMenu="matMenu">
  <button mat-menu-item (click)="download()">
    <mat-icon>cloud_download</mat-icon>
    <span>Download</span>
  </button>

  @if (canCopyToPatientFiles()) {
    <button mat-menu-item (click)="copyToPatientFiles()">
      <mat-icon>file_copy</mat-icon>
      <span>Copy to patient files</span>
    </button>
  }
</mat-menu>
